export default __webpack_public_path__ + "static/B0138-d6fbf04ef780b3fd5cc56f779c18abc3.png";